const state= {
    TaxItems:{
        data:[],
        total:0,
    },
    taxDetail: {},
    relatedTax:{
        data:[],
        total:0,
    },
};

const getters = {
    TaxItems : (state) => state.TaxItems,
    taxDetail : (state) => state.taxDetail,
    relatedTax: (state) => state.relatedTax
};


const actions = {
  async getRelatedTax({commit}, obj){
      let id = obj.tax_id;
      let params = obj.pages;
      let page = params.page || 1;
      let isCMS = params.isCMS || '';
      let limit = params.limit || -1;
      let filter = params.filter || null;
      return new Promise (( resolve, reject ) => {
          global.axios.get(`api/tax/${id}/related-version`, {params:{
                  isCMS:isCMS,
                  page:page,
                  limit:limit,
                  filter:filter,
              }})
              .then(response => {
                  commit( 'setRelatedTax', response.data.data );
                  resolve( response.data.data );
              })
              .catch(error => reject( error ));
      });
  },
  async getTaxItems({commit}, params){
      let page = params.page || 1;
      let isActive = params.isActive || 0;
      let isList = params.isList || 0;
      let isCMS = params.isCMS || '';
      let limit = params.limit || -1;
      let filter = params.filter || null;
      let sortColumn = params.sortColumn || null;
      let sortDirection = params.sortDirection || null;
      let contract_id = params.contract_id || -1;
      return new Promise (( resolve, reject ) => {
          global.axios.get(`api/tax`, {params:{
                    isCMS:isCMS,
                    page:page,
                    limit:limit,
                    filter:filter,
                    isActive: isActive,
                    isList: isList,
                    sortColumn: sortColumn,
                    sortDirection: sortDirection,
            }})
            .then(response => {
                if(!params.isNotSave) {
                    commit( 'setTaxItems', response.data.data );
                }
                resolve( response.data.data );
            })
            .catch(error => reject( error ));
      });
  },
  async getDetail({commit}, params){
      let id = params
      if(id == "0"){
        commit( 'setTaxDetail', {
            id: 0,
            tax_code: "",
            tax_name: "",
            rate: "",
            description: "",
            effective_date: new Date()
          });
        return;
      }
      return new Promise (( resolve, reject ) => {
          global.axios.get(`api/tax/${id}`)
          .then(response => {
              let tax = response.data.data;
              tax.effective_date = new Date(tax.effective_date)
              /*tax.rate = tax.rate ? JSON.stringify(tax.rate) : ''*/
              tax.rate = tax.rate ? parseFloat(parseFloat((tax.rate)*100).toFixed(2)) : ''
              commit( 'setTaxDetail', tax );
              resolve( response.data.data );
          })
          .catch(error => reject( error ));
      });
  },
  async saveTax({commit}, params){
      return new Promise (( resolve, reject ) => {
          if(!params.id){
            global.axios.post(`api/tax`, params)
            .then(response => {
                resolve( response.data.data );
            })
            .catch(error => reject( error ));
          }else{
            global.axios.put(`api/tax/`+ params.id, params)
            .then(response => {
                //debugger
                resolve( response );
            })
            .catch(error => reject( error ));
          }
      });
  },
  async createNewVersion({commit}, params){
    let id = params.id
    return new Promise (( resolve, reject ) => {
        global.axios.post(`/api/tax/${id}/related-version`, {
          tax_name: params.tax_name,
          description: params.description,
          rate: params.rate,
          effective_date: params.effective_date
        })
        .then(response => {
            resolve( response.data.data );
        })
        .catch(error => reject( error ));
    });
  },
  async deleteTax({commit}, ids) {
    return new Promise((resolve, reject) => {
        global.axios.delete(`api/tax`, {
            data: {
                ids: ids
            }
        })
        .then(response => {
            resolve(response);
        })
        .catch(error => reject(error));
    })
  },
  async getSupplierTax({commit}, obj){
    return new Promise (( resolve, reject ) => {
      global.axios.get(`api/tax/supplier-tax-active`, {params:obj})
        .then(response => {
          resolve( response.data.data );
        })
        .catch(error => reject( error ));
    });
  },
}

const mutations = {
    setTaxItems (state, data) {
      state.TaxItems = data;
    },
    createTax(state, data) {
      state.TaxItems = [...state.TaxItems.items, data];
    },
    setTaxDetail(state, data){
      state.taxDetail = data;
    },
    setRelatedTax(state, data){
      state.relatedTax = data
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
